<template>
    <div>
        <div id="wrapper">
            <!-- Topbar Start -->
            <div class="navbar-custom">
                <ul class="list-unstyled topnav-menu float-right mb-0">
                    <li class="d-none d-sm-block">
                        <form class="app-search">
                            <div class="app-search-box">
                                <div class="input-group">
                                    <input type="text" class="form-control" placeholder="Search...">
                                    <div class="input-group-append">
                                        <button class="btn m-0 text-center" type="submit">
                                        <v-icon name="search" style="color:#fff !important" ></v-icon>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </li>

                    <li class="dropdown notification-list" style="width: 70px; margin: 0px;">
                        <a class="nav-link dropdown-toggle nav-user mr-0 waves-effect waves-light"  data-toggle="dropdown" href="#" role="button" style="max-width:50px">
                            <v-icon name="home" style="width:25px; color:rgb(204, 198, 198)"></v-icon>
                        </a>

                        <div class="dropdown-menu dropdown-menu-right profile-dropdown fade-in pt-0" id="mydop" style="font-size: 12px !important; margin-top: -10px;">
                            <!-- item-->
                            <div class="dropdown-header noti-title" >
                                <h6 class="text-overflow m-0" style="font-size: 13px !important;">Welcome !</h6>
                            </div>

                            <router-link to="/updatepassword" tag="a" class="dropdown-item notify-item">
                                <v-icon name="settings" ></v-icon>
                                <span> Change Password</span>
                            </router-link>

                            <div class="dropdown-divider"></div>

                            <!-- item-->
                            <router-link to="/login" tag="a" class="dropdown-item notify-item">
                                <v-icon name="log-out" ></v-icon>
                                <span> Logout</span>
                            </router-link>

                        </div>

                    </li>
                </ul>

                <!-- LOGO -->
                <div class="logo-box pt-2 pl-2" style="width: 240px; height:70px; float: left;">
                    <router-link to="/" class="logo text-center logo-light">
                        <span class="">
                            <img src="../../assets/logo.png" width="150" height="50">
                        </span>
                    </router-link>

                </div>
                <ul class="list-unstyled topnav-menu topnav-menu-left mt-3">
                    <li>
                        <button class="btn btn-link p-0" id="menu-toggle">
                            <v-icon name="menu" style="color:rgb(204, 198, 198); width:28px"></v-icon>
                        </button>
                    </li>
                </ul>
            </div>
            <!-- end Topbar -->

            <!-- page content begins -->
            <div id="pagecontent">

                <!-- sidebar begins -->
                <div id="sidebar">
                    <ul class="sidenav">
                        <li class="menu-title text-light" style="font-size:14px">Admin Dashboard</li>
                        <li class="side">
                            <router-link to="/dashboard" class="list-sub">
                                <v-icon name="home"></v-icon><span class="list-menu"> Dashboard</span>
                            </router-link>
                        </li>

                        <!-- for other admin type -->
                        <div v-if="adminDetails.adminType == 2" class="">
                            <li v-for="(menu, i) in adminMenus" :key="i" class="side">

                                <router-link v-if="menu.hasSubMenu == 0" :to="menu.menuUrl" class="list-sub">
                                    <v-icon name="file"></v-icon><span class="list-menu"> {{ menu.menuName }}</span>
                                </router-link>

                                <div v-else>
                                    <a class="dropdown-btn" style="cursor:pointer">
                                        <v-icon name="folder"></v-icon><span class="list-menu">{{ menu.menuName }} </span><v-icon name="chevron-down"></v-icon>
                                    </a>
                                    <div class="dropbox">
                                        <router-link v-for="(submenu, j) in menu.subMenus" :key="j" :to="submenu.subMenuUrl" class="list-sub ml-2"><v-icon name="list">
                                            </v-icon> <span class="list-menu">{{ submenu.subMenuName }}</span>
                                        </router-link>
                                    </div>
                                </div>
                            </li>
                        </div>

                        <!-- for Super admin Type -->
                        <div v-if="adminDetails.adminType == 1" class="">
                            <li class="side" >
                                <a class="dropdown-btn" style="cursor:pointer">
                                    <v-icon name="folder"></v-icon><span class="list-menu">Agent </span><v-icon name="chevron-down"></v-icon>
                                </a>
                                <div class="dropbox">
                                    <router-link to="/createboardagent" class="list-sub ml-2"><v-icon name="user-plus"></v-icon> <span class="list-menu">Create Board Agent</span></router-link>
                                    <router-link to="/createagent" class="list-sub ml-2"><v-icon name="user-plus"></v-icon> <span class="list-menu">Create Agent</span></router-link>
                                    <router-link to="/listagents" class="list-sub ml-2"><v-icon name="list"></v-icon> <span class="list-menu">List Agents</span></router-link>
                                </div>
                            </li>

                            <li class="side" >
                                <a class="dropdown-btn" style="cursor:pointer">
                                    <v-icon name="folder"></v-icon><span class="list-menu">Beneficiary </span><v-icon name="chevron-down"></v-icon>
                                </a>
                                <div class="dropbox">
                                    <router-link to="/createbeneficiary" class="list-sub ml-2"><v-icon name="user-plus"></v-icon> <span class="list-menu">Create Beneficiary</span></router-link>
                                    <router-link to="/listbeneficiary" class="list-sub ml-2"><v-icon name="list"></v-icon> <span class="list-menu">List Beneficiary</span></router-link>
                                </div>
                            </li>

                            <li class="side" >
                                <a class="dropdown-btn " style="cursor:pointer">
                                    <v-icon name="folder"></v-icon><span class="list-menu">Admin</span><v-icon name="chevron-down"></v-icon>
                                </a>
                                <div class="dropbox">
                                    <router-link to="/createsubadmin" class="list-sub ml-2"><v-icon name="user-plus"></v-icon> <span class="list-menu">Create SubAdmin</span></router-link>
                                    <router-link to="/listadmins" class="list-sub ml-2"><v-icon name="list"></v-icon> <span class="list-menu">List SubAdmins</span></router-link>
                                </div>
                            </li>

                            <li class="side" >
                                <a class="dropdown-btn " style="cursor:pointer">
                                    <v-icon name="folder"></v-icon><span class="list-menu">Items</span><v-icon name="chevron-down"></v-icon>
                                </a>
                                <div class="dropbox">
                                    <router-link to="/createitem" class="list-sub ml-2"><v-icon name="user-plus"></v-icon> <span class="list-menu">Create Items</span></router-link>
                                </div>
                            </li>
                            
                            <li class="side" >
                                <a class="dropdown-btn " style="cursor:pointer">
                                    <v-icon name="folder"></v-icon><span class="list-menu">States</span><v-icon name="chevron-down"></v-icon>
                                </a>
                                <div class="dropbox">
                                    <router-link to="/enrollstate" class="list-sub ml-2"><v-icon name="user-plus"></v-icon> <span class="list-menu">Enroll State</span></router-link>
                                    <router-link to="/liststate" class="list-sub ml-2"><v-icon name="list"></v-icon> <span class="list-menu">List States</span></router-link>
                                </div>
                            </li>

                            <li class="side" >
                                <a class="dropdown-btn " style="cursor:pointer">
                                    <v-icon name="folder"></v-icon><span class="list-menu">Menu</span><v-icon name="chevron-down"></v-icon>
                                </a>
                                <div class="dropbox">
                                    <router-link to="/managemenu" class="list-sub ml-2"><v-icon name="settings"></v-icon> <span class="list-menu">Manage Menu</span></router-link>
                                    <router-link to="/assignmenu" class="list-sub ml-2"><v-icon name="tool"></v-icon> <span class="list-menu">Assign Menu</span></router-link>
                                </div>
                            </li>
                        </div>
                    </ul>
                </div>
                <!-- sidebar ends -->

                <!-- main body begins -->
                <div class="mainbody">
                    <div class="container-fluid">
                        <div class="row">
                            <div class="col-md-12">
                                <!-- start page title -->
                                <div class="row bread" style="padding: 10px 0px 5px 0px; font-size: 11px; color: gray; position:fixed; z-index:1000; width:100%; background:#f2f2f2; margin-top:-10px;margin-bottom:5px">
                                    <div class="col-md-5 ">
                                        <h6 class="page-title text-left">Welcome {{adminName}}  </h6>
                                    </div>
                                    <div class="col-md-5 fades">
                                        <!-- <p class="breadcrumb-item" style="color: #6c757d !important;"><a href="javascript: void(0);" style="text-decoration: none;
                                            background-color: transparent;">Back / </a><span>Dashboard</span>
                                        </p> -->
                                    <!-- <li class="breadcrumb-item active"></li> -->
                                    </div>
                                </div>
                                <!-- end page title -->

                                <!------ INJECTION POINT ---------->
                                <div class="mt-5 bg-light">
                                    <router-view/>
                                </div>
                                <!---------------------------- -->
                            </div>
                        </div>
                    </div>
                </div>
                <!-- main body ends -->
            </div>
            <!-- page content ends -->
        </div>
        <!-- #wrapper ends -->
    </div>

</template>

<script>
    import {mapState, mapGetters, mapActions} from 'vuex'
    import JQuery from 'jquery'

    window.$ = JQuery
    export default {
        name: 'Dashboard',
        data() {
            return {
                typer: 'Agent',
                displayName:'', change_dash:false,
            };
        },
        computed: {
            ...mapGetters(['adminName']),
            ...mapState(['adminDetails', 'adminMenus'])
        },
        created() {
            // update adminDetails in store
            this.updateAdminDetails()
            
            // update adminDetails in store
            this.updateAdminMenu()

            // update token in store
            this.updateToken()

            // add all states to the store
            this.addAllStates()

            // add all states to the store
            this.addAllItems()
        },
        mounted(){
            $("#menu-toggle").click( function (e){e.preventDefault();
                $("#wrapper").toggleClass("menuDisplayed");
            });

            const dropdown = document.querySelectorAll(".dropdown-btn");

            for (let i = 0; i < dropdown.length; i++) {
                dropdown[i].addEventListener("click", function() {
                    this.classList.toggle("active");
                    const dropdownContent = this.nextElementSibling;

                    if (dropdownContent.style.display === "block") {
                        dropdownContent.style.display = "none";
                    } else {
                        dropdownContent.style.display = "block";
                    }
                });
            }
        },
        methods:{
            ...mapActions(['updateAdminDetails', 'updateAdminMenu', 'updateToken', 'addAllStates', 'addAllItems'])

        }
    }

</script>

<style scoped>
    .icon{
        color:#348cd4;
        width: 14px;
    }
    .icon:hover{
        color:#000
    }
    .icon-close{
        color:red
    }

    @import url(https://fonts.googleapis.com/css?family=Poppins:400,500,600,700&display=swap);

    main {
        /* font-family: 'Poppins', Helvetica, sans-serif; */
        font-size:12px
    }
    .navbar-custom{
        background-color:#fff;
        -webkit-box-shadow:0 0 35px 0 rgba(52,59,74,.11);
        box-shadow:0 0 35px 0 rgba(52,59,74,.11);
        padding:0 10px 0 0;
        position:fixed;
        left:0;
        right:0;
        height:70px;
        z-index:100
    }
    .navbar-custom .topnav-menu>li{
        float:left
    }
    .navbar-custom .topnav-menu .nav-link{
        padding:0 15px;
        color:#348cd4;
        min-width:32px;
        display:block;
        line-height:70px;
        text-align:center;
        max-height:70px
    }
    .navbar-custom .app-search{
        overflow:hidden;
        height:70px;
        display:table;
        max-width:180px;
        margin-right:20px
    }
    .navbar-custom .app-search .app-search-box{
        display:table-cell;
        vertical-align:middle
    }
    .navbar-custom .app-search .app-search-box input::-webkit-input-placeholder{
        font-size:.8125rem;
        color:#348cd4
    }
    .navbar-custom .app-search .form-control{
        border:none;
        height:38px;
        padding-left:20px;
        padding-right:0;
        color:#348cd4;
        background-color:rgba(143, 135, 221, 0.07);
        -webkit-box-shadow:none;
        box-shadow:none;
        border-radius:30px 0 0 30px
    }
    .navbar-custom .app-search .input-group-append{
        margin-left:0;
        z-index:4
    }
    .navbar-custom .app-search .btn{
        background-color:#348cd4;
        color:#fff;
        border-color:transparent;
        border-radius:0 30px 30px 0;
        -webkit-box-shadow:none!important;
        box-shadow:none!important
    }
    .navbar-custom .icon{
        color: #348cd4 !important;
    }
    .notification-list{
        margin-left:0
    }
    .notification-list .noti-title{
        background-color:transparent;
        padding:15px 20px
    }
    .notification-list .notify-item{
        padding:12px 20px
    }
    .notification-list .profile-dropdown .notify-item{
        padding:7px 20px
    }
    .nav-user{
        padding:0 12px!important
    }


    /* pagecontent */
    #pagecontent {
        display: block;
        background-color: #f8f6f6;
        width: 100%;
        margin: 0;
        padding: 0;
        position: absolute;
        z-index: 1;
        min-height: 100%;
    }

    /* sidebar */
    #sidebar {
        margin-top: 70px;
        background-color: #348cd4;
        height: 100vh;
        height: 100%;
        overflow-y: auto;
        padding: 0;
        overflow-x: hidden;
        margin-bottom: 30px;
        transition: 0.4s all;
        width: 240px;
        z-index: 99;
        display: block;
        position: fixed;
        -webkit-transition:all .2s ease-out;
        transition:all .2s ease-out;
        -webkit-box-shadow:0 0 35px 0 rgba(154,161,171,.15);
        box-shadow:0 0 35px 0 rgba(154,161,171,.15)
    }
    #sidebar::-webkit-scrollbar-track {
        border: 1px solid #348cd4;
        background-color: #348cd4;
        padding: 2px 0;
    }
    #sidebar::-webkit-scrollbar {
        width: 10px;
        background-color: #424858;
    }
    #sidebar::-webkit-scrollbar-thumb {
        border-radius: 10px;
        box-shadow:inset 0 0 6px #424858;
        background-color:rgba(0,0,0,0.2);
        border:1px solid #348cd4;
    }
    #sidebar a {
        text-decoration: none;
        outline: none;
        text-transform: capitalize;
    }
    #sidebar .menu-title{
        padding:10px 20px;
        letter-spacing:.05em;
        pointer-events:none;
        cursor:default;
        text-indent: 5px;
        font-size:.6875rem;
        text-transform:uppercase;
        color:#6e768e;
        font-weight:600
    }

    /* sidenav */
    .sidenav {
        padding: 0;
        list-style: none;
        margin: 0;
    }
    .sidenav li.side {
        display: block;
        width: 100%;
        line-height: 35px;
        padding: 0;
        margin: 0;
        margin-bottom: 1px;
        position:relative;
        white-space:nowrap;
    }
    .sidenav li.side:last-child {
        margin-bottom: 80px;
    }
    .sidenav li.side a {
        padding:3px 10px;
        color: #444;
        text-indent: 15px;
        text-decoration:none;
        display:block;
        transition:0.4s all;
        font-size:13px;
        outline:none;
        position:relative;
    }
    .sidenav li.side a.active {
        background-color: #125f9e;
    }
    .sidenav li.side a:hover {
        text-decoration: none;
        color: #fff;
        outline: none;
        background-color: #125f9e;
    }
    .sidenav li.side .dropbox {
        line-height:30px;
        display:none;
        transition:0.4s ease-in-out;
        color:#1976d2;
    }
    .sidenav li.side .dropbox a {
        text-indent: 15px;
        display: block;
        font-size: 12px;
        padding: 3px 10px;
    }
    .sidenav li.side .dropbox a:hover {
        text-decoration: none;
        background-color: #176db4;
    }
    .sidenav li.side .dropbox a:active {
        text-decoration: none;
        background-color: #176db4;
    }

    /* maincontent */
    #wrapper.menuDisplayed #sidebar {
        width: 200px;
        z-index: 0;
        display: none;
    }
    #wrapper.menuDisplayed #pagecontent {
        padding-left: 0;
    }
    #wrapper.menuDisplayed .bread {
        width:100% !important;
    }
    #wrapper.menuDisplayed .mainbody {
        z-index: 1;
        position: relative;
        width: 100%;
        padding-left: 0;
    }
    @media (max-width: 768px){
        #sidebar {
            display: none;
        }
        .mainbody {
            padding-left: 0px;
            padding-right: 0px;
        }
        #wrapper.menuDisplayed #sidebar {
            width: 240px;
            z-index: 99;
            display: block;
        }
        #maincontent.menuDisplayed #pagecontent {
            padding-left: 0;
            position: absolute;
            z-index: 1;
        }
        #wrapper.menuDisplayed .mainbody {
            z-index: 0;
            position: fixed;
            padding-left: 0px !important;
        }
    }

    /* mainbody */
    .mainbody {
        position: relative;
        padding: 10px;
        padding-left: 250px;
        z-index: 1;
        margin-top: 70px;
    }
    .mainbody h1 {
        font-size: 33px;
        line-height: 22px;
        color: #30adf4;
        font-weight: bold;
    }
    .mainbody h1 span {
        font-size: 15px;
        color: #777;
        line-height: 15px;
        margin-left: 5px;
        font-weight: 300;
    }
    .mainbody .btn:focus {
        outline: none;
    }
    @media(max-width: 768px){
        .mainbody{
            padding-right: 0;
            padding-left: 0;
        }
    }

    .list-menu {
        color: #fff;
        padding-right: 60px;
        padding-left: 5px;
    }
    .list-menu > .list-sub {
        padding-left: 45px;
    }
    .side .icon {
        color: #fff !important;
    }

    .breadcrumb {
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -ms-flex-wrap: wrap;
        flex-wrap: wrap;
        padding: 1rem 0;
        margin-bottom: 1rem;
        list-style: none;
        background-color: transparent;
        border-radius: .25rem;
    }
    dl, ol, ul {
        margin-top: 0;
        margin-bottom: 1rem;
    }

    #text{
        position: absolute;
        top: 50%;
        left: 50%;
        font-size: 15px;
        color: white;
        transform: translate(-50%,-50%);
        -ms-transform: translate(-50%,-50%);
    }
    #overlay {
        position: fixed;
        display: none;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: rgba(0,0,0,0.9);
        z-index: 2000;
        cursor: pointer;
    }
</style>